<template>
	<div class="battery-heap2">

		<div class="tit">
			电池堆
		</div>

		<div class="content row-center" style="justify-content: space-between">

			<div class="left row-center">
				<div class="row-center">
					<div class="item column-center" style="width: 50%;">
						<div class="k" style="margin-bottom: 15px;">运行状态</div>
						<div class="v">正常</div>
					</div>
					<div class="item column-center" style="width: 50%;">
						<div class="k" style="margin-bottom: 15px;">电池组数</div>
						<div class="v">224</div>
					</div>
				</div>
				<div class="row-center">
					<div class="item column-center" style="width: 50%;">
						<div class="k" style="margin-bottom: 15px;">电压(V)</div>
						<div class="v">627.2</div>
					</div>
					<div class="item column-center" style="width: 50%;">
						<div class="k" style="margin-bottom: 15px;">电流(A)</div>
						<div class="v">139.5</div>
					</div>
				</div>
				<div class="row-center">
					<div class="item column-center" style="width: 50%;">
						<div class="k" style="margin-bottom: 15px;">SOC(剩余电量%)</div>
						<div class="v">{{battery}}</div>
					</div>
					<div class="item column-center" style="width: 50%;">
						<div class="k" style="margin-bottom: 15px;">SOH(健康度%)</div>
						<div class="v">99</div>
					</div>
					<img src="../../assets/img/stack.png" alt="" class="imgshow">
				</div>
				<div class="row-center">
					<div class="item column-center" style="width: 50%;">
						<div class="k" style="margin-bottom: 15px;">可充电量(kWh)</div>
						<div class="v">0</div>
					</div>
					<div class="item column-center" style="width: 50%;">
						<div class="k" style="margin-bottom: 15px;">可放电量(kWh)</div>
						<div class="v">160</div>
					</div>
				</div>
			</div>
			<div class="right">
				<el-scrollbar style="height:100%">
				<ul style="padding: 16px;line-height: 44px;">
					<li class="row-center" style="justify-content: space-between">
						<span class="k">单次充电量（kWh）</span><span class="v" style="font-size: 18px !important;">160</span>
					</li>
					<li class="row-center" style="justify-content: space-between">
						<span class="k">单次放电量（kWh）</span><span class="v" style="font-size: 18px !important;">160</span>
					</li>
					<li class="row-center" style="justify-content: space-between">
						<span class="k">累计充电量（kWh）</span><span class="v" style="font-size: 18px !important;">480</span>
					</li>
					<li class="row-center" style="justify-content: space-between">
						<span class="k">累计放电量（kWh）</span><span class="v" style="font-size: 18px !important;">480</span>
					</li>
					<li class="row-center" style="justify-content: space-between">
						<span class="k">最高单体电压（V）</span><span class="v" style="font-size: 18px !important;">3.6</span>
					</li>
					<li class="row-center" style="justify-content: space-between">
						<span class="k">最低单体电压（V）</span><span class="v" style="font-size: 18px !important;">2.8</span>
					</li>
					<li class="row-center" style="justify-content: space-between">
						<span class="k">最高单体充电温度（℃）</span><span class="v" style="font-size: 18px !important;">45</span>
					</li>
					<li class="row-center" style="justify-content: space-between">
						<span class="k">最高单体放电温度（℃）</span><span class="v" style="font-size: 18px !important;">55</span>
					</li>
					<li class="row-center" style="justify-content: space-between">
						<span class="k">最低单体充电温度（℃）</span><span class="v" style="font-size: 18px !important;">10</span>
					</li>
					<li class="row-center" style="justify-content: space-between">
						<span class="k">最低单体放电温度（℃）</span><span class="v" style="font-size: 18px !important;">0</span>
					</li>
					<li class="row-center" style="justify-content: space-between">
						<span class="k">最大组SOC（%）</span><span class="v" style="font-size: 18px !important;">100</span>
					</li>
					<li class="row-center" style="justify-content: space-between">
						<span class="k">最小组SOC（%）</span><span class="v" style="font-size: 18px !important;">20</span>
					</li>
				</ul>
				</el-scrollbar>
			</div>

		</div>

	</div>
</template>

<script>
	export default {
		name: "BatteryHeap2",
		props:{
			currentLoop:Object,
			battery:String
		},
	}
</script>

<style scoped lang="less">
	.battery-heap2 {
		overflow: hidden;
		height: 42vh;
		background: rgba(0, 0, 0, .15);

		.k, .v {
			font-size: 16px;
			font-weight: 400;
			color: #333333;
		}

		.v {
			font-size: 36px !important;
			font-weight: bold;
			color: #0D94FF !important;
		}

		.tit {
			height: 56px;
			line-height: 56px;
			padding: 0 26px;
			margin-bottom: 1px;
			background: #ffffff;
			font-size: 18px;
			font-weight: bold;
			color: #333333;
		}


		.content {
			height: 88%;
			padding: 24px;
			background: #ffffff;

			.left {
				width: 69%;
				height: 100%;
				background: #ffffff;
				justify-content: space-between;
				align-content: space-between;

				> div {
					width: 49%;
					height: 49%;
					background: #F7F6F9;
					border-radius: 8px;
					position: relative;
				}
				.imgshow{
					height: 100%;
					position: absolute;
					right: 0;
					bottom: 0;
				}
			}

			.right {
				width: 29%;
				background: #F7F6F9;
				height: 100%;
				// overflow: scroll;

			}
		}


	}
</style>
